import { defineMessages } from 'react-intl';

export default defineMessages({

    qty: {
        id: 'formsOrdering.component.forms-order.QTY',
        defaultMessage: 'QTY'
    },
    category:{
        id: "formsOrdering.component.forms-order.CATEGORY",
        defaultMessage: "CATEGORY" 
    },
    formNo: {
        id: "formsOrdering.component.forms-order.FORM NO.",
        defaultMessage: "FORM NO." 
    },
    state: {
        id: 'formsOrdering.component.forms-order.STATE',
        defaultMessage: 'STATE'
    },    
    forms: {
        id: "formsOrdering.component.forms-order.Forms",
        defaultMessage: "Forms"
    },
    errorPlaceOrder: {
        id: 'formsOrdering.component.forms-order.Error placing order!',
        defaultMessage: 'Error placing order!'
    },
    fieldInvalid: {
        id: 'formsOrdering.component.forms-order.Invalid value, The field cannot be empty!',
        defaultMessage: 'Invalid value, The field cannot be empty!'
    },    
});
